/**
 * Carte de section : un en-tête, un contenu.
 *
 * Chaque page redessinait ses propres encadrés, avec des arrondis et des
 * ombres légèrement différents. Les regrouper ici est ce qui donne à
 * l'ensemble l'air d'avoir été dessiné d'un seul tenant.
 */
import React from 'react';
import { C, E, RAYON, OMBRE, T } from '../theme';

export default function Carte({ titre, precision, actions, children, sansPadding, style }) {
  return (
    <section style={{
      background: C.surface,
      border: `1px solid ${C.bordure}`,
      borderRadius: RAYON.lg,
      boxShadow: OMBRE.carte,
      display: 'flex', flexDirection: 'column',
      minWidth: 0,
      ...style,
    }}>
      {titre && (
        <header style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: E.md, padding: `${E.md} ${E.lg}`,
          borderBottom: `1px solid ${C.bordure}`,
        }}>
          <div style={{ minWidth: 0 }}>
            <h2 style={{ fontSize: '14px', fontWeight: 600, color: C.texte, margin: 0 }}>
              {titre}
            </h2>
            {precision && (
              <div style={{ fontSize: '12px', color: C.texteFaible, marginTop: '1px' }}>
                {precision}
              </div>
            )}
          </div>
          {actions}
        </header>
      )}
      <div style={{ padding: sansPadding ? 0 : E.lg, flex: 1, minWidth: 0 }}>
        {children}
      </div>
    </section>
  );
}

/** Intitulé de groupe, au-dessus d'une rangée d'indicateurs. */
export function TitreGroupe({ children, precision }) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: E.sm,
                  margin: `0 0 ${E.md}` }}>
      <span style={T.groupe}>{children}</span>
      {precision && (
        <span style={{ fontSize: '12.5px', color: C.texteFaible }}>{precision}</span>
      )}
    </div>
  );
}
